import React from 'react';
import { Fab, Box } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useLocation } from 'react-router-dom';

const WhatsAppButton = () => {
  const location = useLocation();
  const phoneNumber = '908504744836'; // +90850 474 48 36
  const message = 'Merhaba, destek almak istiyorum.';
  
  // Admin paneli ve korumalı sayfalarda butonu gösterme
  const adminRoutes = [
    '/dashboard',
    '/bookings',
    '/profile',
    '/cartypes',
    '/cars',
    '/addbookings',
    '/promos',
    '/users',
    '/notifications',
    '/addtowallet',
    '/userwallet',
    '/withdraws',
    '/sos',
    '/complain',
    '/allreports',
    '/settings',
    '/paymentsettings',
  ];

  // Eğer admin panelindeyse butonu gösterme
  const isAdminRoute = adminRoutes.some(route => location.pathname.startsWith(route));
  
  if (isAdminRoute) {
    return null;
  }
  
  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 1,
      }}
    >
      {/* Baloncuk Yazı */}
      <Box
        sx={{
          backgroundColor: 'white',
          color: '#25D366',
          padding: '12px 18px',
          borderRadius: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          fontWeight: 600,
          fontSize: '15px',
          letterSpacing: '0.3px',
          position: 'relative',
          whiteSpace: 'nowrap',
          animation: 'bounce 2s infinite',
          '@keyframes bounce': {
            '0%, 100%': {
              transform: 'translateY(0)',
            },
            '50%': {
              transform: 'translateY(-5px)',
            },
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: '-8px',
            right: '20px',
            width: 0,
            height: 0,
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: '8px solid white',
          },
        }}
      >
        💬 Nasıl yardımcı olabiliriz?
      </Box>

      {/* WhatsApp Butonu */}
      <Fab
        color="success"
        aria-label="whatsapp"
        onClick={handleClick}
        sx={{
          backgroundColor: '#25D366',
          color: 'white',
          '&:hover': {
            backgroundColor: '#128C7E',
            transform: 'scale(1.1)',
          },
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          transition: 'all 0.3s ease',
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 32 }} />
      </Fab>
    </Box>
  );
};

export default WhatsAppButton;

